export class Type {
    static getDefault(): any {
        return null;
    }

    static toValue(value): any {
        return value;
    }
}

export interface TypeInterface<T> {
    [x: string]: any;

    getDefault(): T;

    toValue(value: any): T;
}
